export default class AsyncTaskExecutor {
	#pendingTasks = [];
	#activeTask;

	/**
	 *
	 * @param {AsyncTask} task
	 */
	submit(task) {
		return new Promise((resolve, reject) => {
			this.#pendingTasks.push({task, resolve, reject});
			this.#processNextTask();
		});
	}

	killAll() {
		this.#pendingTasks.forEach(({task}) => task.abort());
		this.#pendingTasks = [];
		if (this.#activeTask)
			this.#activeTask.abort();
	}

	killByName(name) {
		this.#pendingTasks = this.#pendingTasks.filter(({task}) => task.name !== name);
		if (this.#activeTask && this.#activeTask.name === name)
			this.#activeTask.abort();
	}

	killByTag(tag) {
		this.#pendingTasks = this.#pendingTasks.filter(({task}) => !task.tags.includes(tag));
		if (this.#activeTask && this.#activeTask.tags.includes(tag))
			this.#activeTask.abort();
	}

	queueLength() {
		return this.#pendingTasks.length;
	}

	getActiveTask() {
		return this.#activeTask;
	}

	/**
	 * For testing purposes only
	 * @returns {Promise<unknown>}
	 * @private
	 */
	_waitUntilAllTasksFinished() {
		return new Promise(resolve => {
			const checkFinished = () => {
				if (this.#pendingTasks.length === 0 && !this.#activeTask) {
					resolve();
				} else {
					setTimeout(checkFinished, 50);
				}
			};
			checkFinished();
		});
	}

	#processNextTask() {
		if (!this.#activeTask && this.#pendingTasks.length > 0) {
			const {task, resolve, reject} = this.#pendingTasks.shift();
			if (task.aborted) {
				reject('Task aborted');
				this.#processNextTask();
				return;
			}
			this.#activeTask = task;
			task.run()
				.then(result => {
					if (!task.aborted) {
						resolve(result);
						this.#activeTask = null;
						this.#processNextTask();
					}
				})
				.catch(error => {
					reject(error);
					this.#activeTask = null;
					this.#processNextTask();
				});
			task.onAbort(() => {
				reject("Task aborted")
				this.#activeTask = null;
				this.#processNextTask();
			});
		}
	}
}
